import {
  firebase,
  functions,
  auth,
  db,
  storageRef,
  googleAuthProvider,
  facebookAuthProvider,
} from "auth/FirebaseAuth";
import { getStorage, ref, deleteObject } from "firebase/storage";
//import { v4 as uuidv4 } from "uuidv4";
import { v4 as uuidv4 } from 'uuid';
const cors = require('cors')({ origin: true });


const FirebaseService = {};

//xlsx function
FirebaseService.fetchDoctorTimeslots = async () => {
  const data = [];
  const snapshot = await db.collection("DoctorTimeslot").get();
  snapshot.forEach((doc) => {
    data.push({ id: doc.id, ...doc.data() });
  });
  return data;
};

FirebaseService.fetchDoctorTimeslotCounts = async () => {
  const timeslotCounts = {};
  const snapshot = await db.collection("DoctorTimeslot").get();

  snapshot.forEach((doc) => {
    const data = doc.data();
    const doctorId = data.doctorId;
    console.log("fetched doctorId",doctorId)

    if (doctorId) {
      timeslotCounts[doctorId] = (timeslotCounts[doctorId] || 0) + 1;
    }
  });

  return timeslotCounts; // Returns an object { doctorId1: count, doctorId2: count, ... }
};

FirebaseService.fetchUserTimeslotCounts = async () => {
  const timeslotCounts = {};
  const snapshot = await db.collection("DoctorTimeslot").get();

  snapshot.forEach((doc) => {
    const data = doc.data();
    const bookeduser = data.bookeduser; // Fetch the userId who booked the timeslot
    console.log("Fetched bookuser: ", bookeduser);
  

    if (bookeduser) {
      timeslotCounts[bookeduser] = (timeslotCounts[bookeduser] || 0) + 1;
    }
  });

  return timeslotCounts; // Returns { userId1: count, userId2: count, ... }
};

//end here!

FirebaseService.signInEmailRequest = async (email, password) =>
  await auth
    .signInWithEmailAndPassword(email, password)
    .then((user) => user)
    .catch((err) => err);

FirebaseService.signInEmailRequest = async (email, password) =>
  await auth
    .signInWithEmailAndPassword(email, password)
    .then((user) => user)
    .catch((err) => err);

FirebaseService.signOutRequest = async () =>
  await auth
    .signOut()
    .then((user) => user)
    .catch((err) => err);

FirebaseService.signInGoogleRequest = async () =>
  await auth
    .signInWithPopup(googleAuthProvider)
    .then((user) => user)
    .catch((err) => err);

FirebaseService.signInFacebookRequest = async () =>
  await auth
    .signInWithPopup(facebookAuthProvider)
    .then((user) => user)
    .catch((err) => err);

FirebaseService.signUpEmailRequest = async (email, password) =>
  await auth
    .createUserWithEmailAndPassword(email, password)
    .then((user) => user)
    .catch((err) => err);

const getFirestoreRef = (path) => firebase.firestore().collection(path);

FirebaseService.fetchDocument = async (collection, id) => {
  const document = await getFirestoreRef(collection).doc(id).get();
  if (!document.exists) return null;
  return { id: document.id, ...document.data() };
};

FirebaseService.fetchCollection = async (collection, options = {}) => {
  const data = [];
  let baseQuery = getFirestoreRef(collection);

  if (options.queries) {
    const { queries } = options;

    queries.forEach(({ attribute, operator, value }) => {
      if (attribute === "uid")
        attribute = firebase.firestore.FieldPath.documentId();
      baseQuery = baseQuery.where(attribute, operator, value);
    });
  }

  if (options.sort) {
    const { attribute, order } = options.sort;
    baseQuery = baseQuery.orderBy(attribute, order);
  }

  (await baseQuery.get()).forEach((doc) => {
    data.push({ id: doc.id, ...doc.data() });
  });

  return data;
};

FirebaseService.uploadImage = async (fileName, file) => {
  console.log("filename : " + fileName);
  let url = await storageRef.ref("uploads").child(fileName).put(file);
  return url.ref.getDownloadURL();
};

// In your FirebaseService.js file
// In FirebaseService.js
// In FirebaseService.js
FirebaseService.addDoctorCategory = async (categoryData) => {
  try {
    await db.collection("DoctorCategory").add({
      ...categoryData
    });
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};


FirebaseService.removeDoctorCategory = async (categoryId) => {
  try {
    await db.collection("DoctorCategory").doc(categoryId).delete();
  } catch (error) {
    throw error;
  }
};
FirebaseService.createDoctorCategory = async (categoryName, iconUrl) => {
  try {
    const newDoc = await db.collection("DoctorCategory").add({
      categoryName,
      iconUrl,
    });
    console.log("🟢 Created new category with ID:", newDoc.id);
  } catch (error) {
    console.error("🔴 Failed to create category:", error);
  }
};

FirebaseService.getDoctorById = async (doctorId) => {
try {
    console.log(doctorId);
    const doc = await db.collection("Doctors").doc(doctorId).get();
    if (doc.exists) {
      return { id: doc.id, ...doc.data() };
    }
    return null;
  } catch (error) {
    console.error("Error fetching doctor:", error);
    return null;
  }
}


FirebaseService.editDoctorCategory = async (id, categoryName, iconUrl) => {
  try {
    const dataToUpdate = { categoryName };

    if (iconUrl != null) {
      dataToUpdate.iconUrl = iconUrl;
    }

    console.log("🟡 Attempting to write category:", { id, dataToUpdate });

    await db.collection("DoctorCategory").doc(id).set(dataToUpdate, { merge: true });

    console.log("🟢 Successfully added/updated category:", id);
  } catch (error) {
    console.error("🔴 Firestore write failed:", error);
  }
};



FirebaseService.removeTopRatedDoctor = async (topRatedId) => {
  try {
    let snapshot = await db
      .collection("TopRatedDoctor")
      .where("doctorId", "==", topRatedId)
      .get();
    await snapshot.docs.at(0).ref.delete();
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 124 ~ FirebaseService.removeTopRatedDoctor= ~ error",
      error
    );

    throw error;
  }
};

FirebaseService.addTopRatedDoctor = async (doctorId) => {
  try {
    await db.collection("TopRatedDoctor").add({ doctorId });
  } catch (error) {
    throw error;
  }
};

FirebaseService.deleteDoctorAccount = async (doctorId) => {
  try {
    var addMessage = firebase.functions().httpsCallable("deleteDoctor");
    await addMessage({ doctorId: doctorId });
    console.log("delete doctor");
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 160 ~ FirebaseService.deleteDoctorAccount ~ error",
      error
    );
    throw error;
  }
};
FirebaseService.deleteUser = async (userId) => {
  try {
    var addMessage = firebase.functions().httpsCallable("deleteUser");
    await addMessage({ userId: userId });
    console.log("delete user");
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 160 ~ FirebaseService.deleteDoctorAccount ~ error",
      error
    );
    throw error;
  }
};

FirebaseService.countCollection = async (documentName) => {
  let size = await db
    .collection(documentName)
    .get()
    .then((snap) => {
      return snap.size; // will return the collection size
    });
  return size;
};

FirebaseService.setPercentage = async (data) => {
  console.log(data);
  await db
    .collection("Settings")
    .doc("withdrawSetting")
    .set({ percentage: data.data.percentage, cgst: data.data.cgst, sgst: data.data.sgst,igst: data.data.igst, tcs: data.data.tcs, tds: data.data.tds, nogstTds: data.data.nogstTds, sacAdvisor: data.data.sacAdvisor,  sacBizboost: data.data.sacBizboost, gstno: data.data.gstno,name: data.data.name, address: data.data.address,pin: data.data.pin, country: data.data.country, state: data.data.state, stateCode: data.data.stateCode, advhour: data.data.advhour,advminute :data.data.advminute });

  };

FirebaseService.getWithdrawalSettings = async () => {
  try {
    let snapshot = await db.collection("Settings").doc("withdrawSetting").get();
    if (!snapshot.exists) return {};
    return snapshot.data();
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 206 ~ FirebaseService.getWithdrawalSettings= ~ error",
      error
    );
    throw error;
  }
};

FirebaseService.getImageCarousel = async () => {
  try {
    let data = [];
    let snapshot = await db
      .collection("Settings")
      .doc("imageCarousel")
      .collection("listImage")
      .get();
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 213 ~ FirebaseService.getImageCarousel= ~ snapshot",
      snapshot.docs
    );
    snapshot.docs.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    return data;
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 212 ~ FirebaseService.getImageCarousel= ~ error",
      error
    );
    throw error;
  }
};
FirebaseService.removeImageCarousel = async (data) => {
  console.log(
    "🚀 ~ file: FirebaseService.js ~ line 232 ~ FirebaseService.removeImageCarousel= ~ data",
    data
  );
  try {
    await db
      .collection("Settings")
      .doc("imageCarousel")
      .collection("listImage")
      .doc(data.data.imageId)
      .delete();

    let picRef = storageRef.refFromURL(data.data.imageUrl);
    picRef.delete();
  } catch (error) {
    throw error;
  }
};
FirebaseService.saveImageCarouselData = async (data) => {
  try {
    await db
      .collection("Settings")
      .doc("imageCarousel")
      .collection("listImage")
      .add({
        imageUrl: data.imageUrl,
        fileName: data.fileName,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
      });
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 231 ~ FirebaseService.saveImageCarouselData= ~ error",
      error
    );
    throw error;
  }
};
// Add these methods to your FirebaseService class

// In your FirebaseService.js, add these methods:

FirebaseService.getCategoryRequests = async () => {
  const snapshot = await db.collection("categoryRequest").get();
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

FirebaseService.removeCategoryRequest = async (id) => {
  await db.collection("categoryRequest").doc(id).delete();
};

FirebaseService.addDoctorCategory = async (data) => {
  const docRef = await db.collection("DoctorCategory").add(data);
  return docRef.id;
};

FirebaseService.markWithdrawalRequestPending = async (record) => {
  try {
    console.log(record.id);
    //console.log(newField);
    
     if(record.status === 'complete'){
      console.log("completed -> pending");
      
    await db
      .collection("WithdrawRequest")
      .doc(record.id)
      .update({ status: "pending", transactionId : "" });

    let transactionSnapshot = await db
      .collection("Transaction")
      .where("withdrawRequestId", "==", record.id)
      .get();
    if (transactionSnapshot.empty) return;
    transactionSnapshot.docs[0].ref.update({ status: "pending" });
    }
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};


FirebaseService.markWithdrawalRequestComplete = async (record) => {
  try {
    console.log(record);
    const transactionId = record.additionalInfo;
    //console.log(newField);
     if(record.status === 'pending'){
      console.log("pending -> complete");
    await db
      .collection("WithdrawRequest")
      .doc(record.id)
      .update({ status: "complete", transactionId : transactionId });

    let transactionSnapshot = await db
      .collection("Transaction")
      .where("withdrawRequestId", "==", record.id)
      .get();
    if (transactionSnapshot.empty) return;
    transactionSnapshot.docs[0].ref.update({ status: "success" });
     }
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};
FirebaseService.markProblemAcceptRequestComplete = async (record) => {
  try {
    console.log(record);
    //var addMessage = firebase.functions().httpsCallable("AutoBizinvoice");
    //const response = await addMessage({ timeSlotId: '7zVMN3DrGuKBtL0oH6tW' });
    //console.log("delete doctor");
    // if (response.data.success) {
    //   // Access the invoice ID
    //   const invoiceId = response.data.invoiceId;
    //   console.log("Invoice ID:", invoiceId);
     
    //   // Handle other data if needed
    //   // ...
    //   } else {
    //   // Handle any errors or failure
    //   console.error("Invoice generation failed");
    //   }
    //console.log(record);
    const currentDate = firebase.firestore.FieldValue.serverTimestamp();
    const referenceIdRef = record.referenceIdRef1;
    console.log(referenceIdRef);
    const selectedDateRef = record.selectedDateRef1;
    const descriptionRef = record.descriptionRef1;
    console.log("problem working");
    //  if(record.status === 'pending'){
      //console.log("pending -> complete");
    await db
      .collection("Problem")
      .doc(record.id)
      .update({ paymentRefId : referenceIdRef,paymentDate:selectedDateRef, acceptedDescription:descriptionRef,actionTimestamp: currentDate,status:"Accepted"});

    // let transactionSnapshot = await db
    //   .collection("Transaction")
    //   .where("withdrawRequestId", "==", record.id)
    //   .get();
    // if (transactionSnapshot.empty) return;
    // transactionSnapshot.docs[0].ref.update({ status: "success" });
    //  }
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};
FirebaseService.markProblemRejectRequestComplete = async (record) => {
  //console.log("aswany");

  
  try {
    console.log(record);
    const currentDate = firebase.firestore.FieldValue.serverTimestamp();
    const descriptionRef = record.descriptionRef;
    await db
      .collection("Problem")
      .doc(record.id)
      .update({ rejectedDescription:descriptionRef,actionTimestamp: currentDate,status:"Rejected"});
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};

FirebaseService.markProblemRejectWithInvoiceRequestComplete = async (record) => {
  try {
    console.log(record.timeSlot);
    var addMessage1 = firebase.functions().httpsCallable("AutoBizinvoice");
    const response = await addMessage1({ timeSlotId: record.timeSlot });
    console.log("Add problem invoice"+response.data.success);
    if (response.data.success === true) {
      console.log(response.data.invoiceId);
      // Access the invoice ID
      const invoiceId = response.data.invoiceId;
      // if(invoiceId !== '')
      // {
        console.log("Invoice ID if :", invoiceId);
     
        console.log(record);
        const currentDate = firebase.firestore.FieldValue.serverTimestamp();
        const descriptionRef = record.descriptionRef;
        await db
          .collection("Problem")
          .doc(record.id)
          .update({ rejectWithInvoiceDescription:descriptionRef,actionTimestamp: currentDate,invoiceId:invoiceId,status:"RejectedwithInvoice",rejectInvoiceStatus:"1"});

      // }
      // else
      // {
        

        // }
      
      } else {
         alert("Already invoice was generated" );
      //  await db
      // .collection("Problem")
      // .doc(record.id)
      // .update({status:"Pending",rejectInvoiceStatus:"0"});
      // Handle any errors or failure
      // alert("Invoice Already created.. So please reject");
      
      
      }
    
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};
  
// problem by advisor //
FirebaseService.markProblemAdvisorAcceptRequestComplete = async (record) => {
  try {
    console.log(record);
    const currentDate = firebase.firestore.FieldValue.serverTimestamp();
  
    const descriptionAdvisor1 = record.descriptionAdvisor1;
    console.log("problem working"+descriptionAdvisor1 );
    
    await db
      .collection("Problem")
      .doc(record.id)
      .update({ acceptedDescription:descriptionAdvisor1,actionTimestamp: currentDate,status:"Accepted"});

  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markProblemAcceptRequestComplete ~ error",
      error
    );

    throw error;
  }
};


FirebaseService.markProblemAdvisorRejectRequestComplete = async (record) => {
  //console.log("aswany");

  
  try {
    console.log(record);
    const currentDate = firebase.firestore.FieldValue.serverTimestamp();
    const descriptionRef = record.descriptionRef;
    await db
      .collection("Problem")
      .doc(record.id)
      .update({ rejectedDescription:descriptionRef,actionTimestamp: currentDate,status:"Rejected"});
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};

FirebaseService.markProblemAdvisorAcceptWithInvoiceRequestComplete = async (record) => {
  try {
    console.log(record.timeSlot);
    var addMessage1 = firebase.functions().httpsCallable("AutoBizinvoice");
    const response = await addMessage1({ timeSlotId: record.timeSlot });
    console.log("Add problem invoice"+response.data.success);
    if (response.data.success === true) {
      console.log(response.data.invoiceId);
      // Access the invoice ID
      const invoiceId = response.data.invoiceId;
      // if(invoiceId !== '')
      // {
        console.log("Invoice ID if :", invoiceId);
     
        console.log(record);
        const currentDate = firebase.firestore.FieldValue.serverTimestamp();
        const descriptionRef = record.descriptionRef;
        await db
          .collection("Problem")
          .doc(record.id)
          .update({ acceptWithInvoiceDescription:descriptionRef,actionTimestamp: currentDate,invoiceId:invoiceId,status:"AcceptedwithInvoice",rejectInvoiceStatus:"1"});

     
      } else {
         alert("Already invoice was generated" );
    
      
      
      }
    
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 224 ~ FirebaseService.markWithdrawalRequestComplete ~ error",
      error
    );

    throw error;
  }
};
  

FirebaseService.setDoctorAccountStatus = async (record, status) => {
  try {
    await db
      .collection("Doctors")
      .doc(record)
      .update({ accountStatus: status ,"isRequireReactivation":false});
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 240 ~ FirebaseService.setDoctorAccountStatus= ~ error",
      error
    );

    throw error;
  }
};

// ::::Edit Doctor Details:::::
FirebaseService.updateEditDoctorDetails = async (doctorId, updatedData) => {
  try {
    if (!doctorId || !updatedData) {
      throw new Error("Invalid doctorId or updatedData");
    }

    console.log("Data in firebaseServices.js", doctorId, updatedData);

    // Extract categoryIds from updatedData
    const categoryIds = (updatedData.doctorCategories || []).map(
      (cat) => cat.categoryId
    );

    // Remove category-related fields
    const {
      doctorCategories,
      doctorCategory,
      categories,
      ...restWithoutCategories
    } = updatedData;

    // Filter out undefined or null values
    const safeUpdateData = {};
    for (const key in restWithoutCategories) {
      if (
        restWithoutCategories[key] !== undefined &&
        restWithoutCategories[key] !== null
      ) {
        safeUpdateData[key] = restWithoutCategories[key];
      }
    }

    // ✅ Update Doctors document only with specified fields
    if (Object.keys(safeUpdateData).length > 0) {
      await db.collection("Doctors").doc(doctorId).update(safeUpdateData);
      console.log("Doctor fields updated:", safeUpdateData);
    } else {
      console.log("No fields to update in Doctors document.");
    }

    // Find matching user by doctorId
    const userQuery = await db
      .collection("Users")
      .where("doctorId", "==", doctorId)
      .get();

    if (!userQuery.empty) {
      const userDoc = userQuery.docs[0];
      const userId = userDoc.id;

      // ✅ Update categoryIds in UserCategoryMap (merge only)
      await db.collection("UserCategoryMap").doc(userId).set(
        {
          categoryIds: categoryIds,
          timestamp: new Date(),
        },
        { merge: true } // ✅ prevents overwriting existing fields
      );

      console.log("UserCategoryMap updated with categories:", categoryIds);
    } else {
      console.log("No matching user found for doctorId:", doctorId);
    }
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ updateEditDoctorDetails ~ error",
      error
    );
  }
};




// ::::Get DoctorDetails By Id::::::

FirebaseService.getDoctorDetailsById=async(doctorId)=>{
  try{
    if (!doctorId) {
      throw new Error("Invalid doctorId or updatedData");
    }
    // console.log("DoctorId:::::::::in firebaseServices::",doctorId);
    
    const doctorRef = db.collection('Doctors').doc(doctorId);
      const doc = await doctorRef.get(); 
      
      const fetchedData = doc.data();

      if (!doc.exists) {
        throw new Error('Doctor not found');
      }

      return { id: doc.id, ...fetchedData };

  }catch(err){
    throw new Error('Error fetching doctor details: ' + err.message);
  }
}

// ::::::Add new Doctor Details::::::::

FirebaseService.addNewDoctorDetails=async(selectedId,doctorDetails)=>{
  try {
    const newDoctor = await db.collection("Doctors").add(doctorDetails);
    await db.collection("Users").doc(selectedId).update({ doctorId: newDoctor.id });
    return newDoctor.id;
  } catch (error) {
    console.error("Error adding new doctor:", error);
    throw error; 
  }
}

// :::::::::GET StateDetails::::::::

FirebaseService.getStateDetails=async()=>{
  try{
   const stateData=db.collection("State");
   const snapshot = await stateData.get(); 
   const states = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
  console.log("state in Firebase::::",states);
  
   return states;
  }catch(err){
    throw new Error('Error fetching state details: ' + err.message);
  }
}

// :::::::::GET CountryDetails::::::::

FirebaseService.getCountryDetails=async()=>{
  try{
   const countryData=db.collection("Country");
   const snapshot = await countryData.get(); 
   const country = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
  console.log("Country in Firebase::::",country);
  
   return country;
  }catch(err){
    throw new Error('Error fetching Country details: ' + err.message);
  }
}

// :::::::::GET Doctor Category Details::::::::
FirebaseService.getDoctorCategoryDetails = async () => {
  try {
    console.log("📡 Fetching DoctorCategory from Firebase...");
    
    const categoryData = db.collection("DoctorCategory");
    const snapshot = await categoryData.get(); 

    if (snapshot.empty) {
      console.log("⚠️ Doctor Category is Empty :::::::::");
      return [];
    }

    const category = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    console.log("✅ DoctorCategory fetched successfully:");
    category.forEach((cat, index) => {
      console.log(`🔸 [${index + 1}] ${cat.id}:`, cat);
    });

    return category;
  } catch (err) {
    console.error("❌ Error fetching doctorCategory details:", err.message);
    throw new Error('Error fetching doctorCategory details: ' + err.message);
  }
};


//::::Edit User Details:::::

FirebaseService.updateEditUserDetails=async(userId,updatedData)=>{
  try{
    if (!userId || !updatedData) {
      throw new Error("Invalid UserId or updatedData");
    }
    console.log("Data in firebaseServies.js",userId,updatedData);
    
   await db.collection("Users").doc(userId).update(updatedData);
  }catch(error){
    throw new Error('Error at Edit User Dettails firbase catch:::: ' + error.message);
  }
}




FirebaseService.addFaq = async (question, answer) => {
  try {
    let faqRef = await db.collection("Faq").add({
      question: question,
      answer: answer,
    });
    return faqRef.id;
  } catch (error) {
    throw error;
  }
};
FirebaseService.deleteFaq = async (faqId) => {
  try {
    await db.collection("Faq").doc(faqId).delete();
  } catch (error) {
    throw error;
  }
};
FirebaseService.updateTermsAndConditions = async (data) => {
  try {
    await db.collection("TermsAndCondition").doc(data.id).update(data);
    //console.log("Success update TermsAndCondition");
  } catch (error) {
   // console.log("Error update TermsAndCondition");
    throw error;
  }
};
FirebaseService.updateprivacyPolicys = async (data) => {
  console.log(data);
  try {
    await db.collection("PrivacyPolicy").doc(data.id).update(data);
    //console.log("Success update privacy");
  } catch (error) {
    //console.log("Error update privacy");
    throw error;
  }
};
FirebaseService.getLanguage = async () => {
  try {
    var languageData = await db
      .collection("Settings")
      .doc("clientLanguage")
      .get();
    return languageData.data();
  } catch (error) {
    throw error;
  }
};
FirebaseService.getAppTextAdvisor = async () => {
  try {
    var languageData = await db
      .collection("Settings")
      .doc("advisorLanguage")
      .get();
    return languageData.data();
  } catch (error) {
    throw error;
  }
};
FirebaseService.updateAppText = async (data) => {
  console.log(
    "🚀 ~ file: FirebaseService.js ~ line 344 ~ FirebaseService.updateAppText= ~ data",
    data
  );
  try {
    await db.collection("Settings").doc("clientLanguage").update(data);
    await db
      .collection("Settings")
      .doc("languageVersion")
      .update({ version: firebase.firestore.FieldValue.increment(1) });
  } catch (error) {
    throw error;
  }
};
FirebaseService.updateAppTextAdvisors = async (data) => {
  console.log(
    "🚀 ~ file: FirebaseService.js ~ line 344 ~ FirebaseService.updateAppText= ~ data",
    data
  );
  try {
    await db.collection("Settings").doc("advisorLanguage").update(data);
    await db
      .collection("Settings")
      .doc("languageVersion")
      .update({ version: firebase.firestore.FieldValue.increment(1) });
  } catch (error) {
    throw error;
  }
};


FirebaseService.getRazorpaySettings = async () => {
  
  try {
    let snapshot = await db.collection("Settings").doc("razorPay").get();
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 206 ~ FirebaseService.getRazorpaySettings= ~ snapshot",
      snapshot.data()
    );
    if (!snapshot.exists) return {};
    return snapshot.data();
  } catch (error) {
    console.log(
      "🚀 ~ file: FirebaseService.js ~ line 206 ~ FirebaseService.getRazorpaySettings= ~ error",
      error
    );
    throw error;
  }
};

FirebaseService.setRazorpay = async (data) => {
  console.log(data);
  await db
    .collection("Settings")
    .doc("razorPay")
    .set({ liveKey: data.data.liveKey, liveKeysecret: data.data.liveKeysecret, testKey: data.data.testKey, testKeysecret: data.data.testKeysecret,  mode: data.data.mode });

  };


  FirebaseService.markCancelledInvoiceComplete = async (record) => {
    try {
      await db
        .collection("Invoice")
        .doc(record.id)
        .update({ action: "complete" });
  
      
    } catch (error) {
      console.log(
        "🚀 ~ file: FirebaseService.js ~ line 2249~ FirebaseService.markCancelledInvoiceComplete ~ error",
        error
      );
  
      throw error;
    }
  };


  FirebaseService.getInstamojoSettings = async () => {
  
    try {
      let snapshot = await db.collection("Settings").doc("instaMojo").get();
      // console.log(
      //   "🚀 ~ file: FirebaseService.js ~ line 206 ~ FirebaseService.getRazorpaySettings= ~ snapshot",
      //   snapshot.data()
      // );
      if (!snapshot.exists) return {};
      return snapshot.data();
    } catch (error) {
      console.log(
        "🚀 ~ file: FirebaseService.js ~ line 206 ~ FirebaseService.getInstamojoSettings= ~ error",
        error
      );
      throw error;
    }
  };
  FirebaseService.setInstamojo = async (data) => {
    console.log(data);
    await db
      .collection("Settings")
      .doc("instaMojo")
      //.set({ liveUrl: data.data.liveUrl, testUrl: data.data.testUrl, instaMode: data.data.instaMode,instaState: data.data.instaState,liveKey: data.data.liveKey, testKey: data.data.testKey, razorMode: data.data.razorMode, razorState: data.data.razorState });
      .set({ instaState: data.data.instaState,liveKey: data.data.liveKey, liveKeysecret: data.data.liveKeysecret,testKey: data.data.testKey, testKeysecret: data.data.testKeysecret, razorMode: data.data.razorMode, razorState: data.data.razorState });
    };
    FirebaseService.changeInactiveDoctor = async (doctorId) => {
      try {
        //console.log("doctorId"+doctorId);
        await db.collection("Doctors").doc(doctorId).update({ accountStatus: "active" });;
      } catch (error) {
        throw error;
      }
    };
export default FirebaseService;
